import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { PortfolioService } from '@irb/irb-clients/portfolios/portfolio.service';
import { IrbClientsEvents, IrbAppEvents } from '@irb-common/events';
import { UtilityService } from '@irb-common/services/utility.service';
import { interval, Subscription } from 'rxjs';

@Component({ standalone: false,
  selector: 'irb-import-model-category-dialog',
  templateUrl: './import-model-category-dialog.component.html',
  styleUrls: ['./import-model-category-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportModelCategoryDialogComponent implements OnInit {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string;
  isUiTest: boolean = false;
  checkModelAndCategorySub: Subscription;


  constructor(
      private readonly ps: PortfolioService,
      public dialogRef: MatDialogRef<ImportModelCategoryDialogComponent>,
      public as: AppService,
      private util: UtilityService) {}

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportPortfolio0', this.file, this.file.name);
    
    this.ps.importModelAndCategory(f).subscribe({
      next: (res: string) => {
        const response = JSON.parse(res);
        if (response?.responseStatus === 'SUCCESS') {
          this.checkImportModelAndCategoryAsyncStatus(response.responseUtilityMap.statusId);
        } else {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Model and Category',
            detail: 'An error occurred processing your request.'
          });
        }
      }, error: () => {}
    });
  }

  checkImportModelAndCategoryAsyncStatus(importStatusId: string) {
    const intervalValue = this.isUiTest ? 0 : 3000;
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.checkModelAndCategorySub = interval(intervalValue).subscribe(() => {
      this.ps.importModelAndCategoryStatus(importStatusId).subscribe((response: any) => {
        if (response.responseUtilityMap?.requestStatus?.toUpperCase() === "COMPLETED") {
          this.checkModelAndCategorySub.unsubscribe();
          this.importModelAndCategoryComplete(response.responseData);
        } else if (response.responseStatus !== "SUCCESS" ||
          (response.responseUtilityMap?.requestStatus && response.responseUtilityMap?.requestStatus?.toUpperCase() === "FAILED")) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Model And Category',
              detail: 'An error occurred processing your request.'
            });
            this.checkModelAndCategorySub.unsubscribe();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          } else if (response.responseUtilityMap?.actionStatus?.reqStatus?.toUpperCase() === "IN_PROGRESS") {
          }
      }, () => {
        this.checkModelAndCategorySub.unsubscribe();
      });
    });
  }

  importModelAndCategoryComplete(res: any) {
    const response = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));

    if(response.status && response.status === "fail") {
      if(response.message) {
        this.errorMessage = response.message;
      } else {
        this.isValidFile = false;
      }
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      return;
    }

    const hasValidRecords = (response.validRecords && response.validRecords.length > 0);
    const hasInvalidRecords = (response.invalidRecords && response.invalidRecords.length > 0);

    if(hasValidRecords && !hasInvalidRecords) {
      this.as.fireEvent(IrbClientsEvents.IMPORT_MODEL_CATEGORY_COMPLETE, response);
    } else if(!hasValidRecords && !hasInvalidRecords) {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'warn',
        summary: 'Import Model and Category',
        detail: 'The import completed without any categories being assigned.'
      });
    } else if(hasInvalidRecords) {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_MODEL_CATEGORY_RESULT, response);
    }

    this.close();
  }
}
